import { inject } from 'mobx-react'
import React, { ReactNode } from 'react'
import type { AuthStore } from './types'

const RestrictedContext = React.createContext(false)

type RestrictedProviderProps = {
  requiredPermission: string
  children: ReactNode
}

type InjectedProps = {
  authStore: AuthStore
}

type RestrictedProviderState = {
  hasPermission: boolean
}

@inject('authStore')
export class RestrictedProvider extends React.PureComponent<RestrictedProviderProps, RestrictedProviderState> {
  state = {
    hasPermission: false,
  }

  componentDidMount() {
    const { authStore, requiredPermission } = this.props as RestrictedProviderProps & InjectedProps

    this.setState({
      hasPermission: authStore.userHasPermission(requiredPermission),
    })
  }

  render() {
    return (
      <RestrictedContext.Provider value={this.state.hasPermission as boolean}>
        {this.props.children}
      </RestrictedContext.Provider>
    )
  }
}

export const RestrictedConsumer = RestrictedContext.Consumer
